module.exports = __webpack_public_path__ + "static/media/James M. Cox - 1920.90691d87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/James M. Cox - 1920.jpg
// module id = 503
// module chunks = 0